var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWriting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 67,
    viewBox: "0 0 102 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 54.1029L12.2717 62.9047C14.8055 64.8833 18.5199 63.2158 18.7254 60.0076L19.4751 48.2992C19.6818 45.0711 23.4355 43.4106 25.963 45.4292L50.1169 64.7191C52.9338 66.9687 57.0553 64.6369 56.5779 61.0638L53.4382 37.5684C53.0827 34.9081 55.3962 32.6595 58.0452 33.0905L68.3835 34.7723C70.9437 35.1888 73.2172 33.0959 73.0134 30.51L72.171 19.8209C71.9442 16.9423 74.7488 14.7791 77.4754 15.7296L90.5109 20.2738C93.1107 21.1801 95.8276 19.25 95.8276 16.4967V7.4674C95.8276 6.11422 96.5117 4.85279 97.6459 4.11474L101 1.93213",
    stroke: "#3F1E11",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriting);
export default __webpack_public_path__ + "static/media/writing.3c4c7ed0f1ce588d48ce921d075bf2ee.svg";
export { ForwardRef as ReactComponent };